import { useContext, useEffect } from 'react';

import { History, Update } from 'history';
import { UNSAFE_NavigationContext } from 'react-router-dom';

const useBackListener = (callback: (...args: any) => void) => {
  const navigator = useContext(UNSAFE_NavigationContext).navigator as History;

  useEffect(() => {
    const listener = ({ location, action }: Update) => {
      if (action === 'POP') {
        callback({ location, action });
      }
    };

    return navigator.listen(listener);
  }, [callback, navigator]);
};

export default useBackListener;
